import { z } from 'zod';
// ─── AI Budget Suggest ────────────────────────────────────────────────────────
export const aiBudgetSuggestInputSchema = z.object({
    description: z.string().max(500).optional(),
});
export const aiBudgetSuggestLineSchema = z.object({
    category: z.string(),
    amount: z.number().int().min(0),
});
export const aiBudgetSuggestResponseSchema = z.object({
    lines: z.array(aiBudgetSuggestLineSchema),
    comment: z.string(),
    nextAvailableAt: z.string(), // ISO — когда снова можно запросить
});
// ─── AI Floor Plan Trace ─────────────────────────────────────────────────────
// Распознавание фото-подложки нейросетью: стены, проёмы и масштаб по подписанным
// размерам. Координаты — в условных единицах (длинная сторона фото = 1000),
// поэтому изотропные: клиент переводит их в px/см сам.
/** ~3 МБ base64 — с запасом для JPEG 1600 px, и под лимитом vision-моделей (5 МБ). */
export const AI_FLOOR_PLAN_IMAGE_MAX_CHARS = 3_000_000;
export const aiFloorPlanTraceInputSchema = z.object({
    attachmentId: z.string(),
    /** Ширина / высота фото — по ним считаются размеры области координат. */
    aspect: z.number().min(0.05).max(20),
    /**
     * Уменьшенная копия фото (data:image/jpeg;base64,…). Без неё провайдер качает
     * оригинал по подписанной ссылке — а до хранилища он может не достучаться,
     * и у vision-моделей лимит на размер картинки.
     */
    image: z
        .string()
        .regex(/^data:image\/(jpeg|png|webp);base64,/)
        .max(AI_FLOOR_PLAN_IMAGE_MAX_CHARS)
        .optional(),
});
export const aiFloorPlanTraceWallSchema = z.object({
    a: z.object({ x: z.number(), y: z.number() }),
    b: z.object({ x: z.number(), y: z.number() }),
    thickness: z.number(),
    openings: z.array(z.object({
        kind: z.enum(['DOOR', 'WINDOW']),
        /** Центр проёма от начала стены a. */
        offset: z.number(),
        width: z.number(),
    })),
});
export const aiFloorPlanTraceResponseSchema = z.object({
    wallsVisible: z.boolean(),
    dimensionsLabeled: z.boolean(),
    thicknessLabeled: z.boolean(),
    advice: z.string(),
    walls: z.array(aiFloorPlanTraceWallSchema),
    /** Область координат walls: x ∈ [0, width], y ∈ [0, height]. */
    width: z.number(),
    height: z.number(),
    /** Сантиметров в одной условной единице — если на плане нашлась подписанная размерная линия. */
    cmPerUnit: z.number().nullable(),
    nextAvailableAt: z.string(), // ISO — когда снова можно запросить
});
//# sourceMappingURL=ai.js.map